import { onShellWidth } from '@components/Page'
import styled from 'styled-components'

// The page surface + footer live in the shared @components/PublicPage shell;
// this file only styles what is specific to the per-section frame.


/** `$onShell` holds the heading to the shell's width inside a full-width column. */
export const TopBar = styled.div<{ $onShell?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 24px;
	${({ $onShell }) => $onShell && onShellWidth}
`
